import {
  Actions,
  createComposable,
  Getters,
  Module,
  Mutations,
} from "vuex-smart-module";
import { loginUser, registerUser, logoutUser } from "@/api/auth.js";
import { root } from "@/store/Store";
import { useUserStore } from "@/store/user";

class AuthState {
  rootCtx = undefined;
}
class AuthGetters extends Getters {}
class AuthMutations extends Mutations {
  setAuth(payload) {
    this.state.rootCtx.mutations.setAuth(payload);
  }
  // COMMENTED OUT - User functionality moved to Pinia UserStore
  // setUser(payload) {
  //   this.state.profileCtx.actions.fetchUser(payload);
  // }
}
class AuthActions extends Actions {
  $init(store) {
    this.state.rootCtx = root.context(store);
  }
  async login(dto) {
    try {
      const response = await loginUser(dto);
      localStorage.setItem("token", response.data.token);
      this.mutations.setAuth(true);
      // Update the Pinia user store with full user data
      const userStore = useUserStore();
      try {
        await userStore.updateStore();
      } catch (error) {
        console.warn('Failed to update user store after login:', error);
      }
    } catch (error) {
      console.error('Login failed:', error);
      // Re-throw so components can handle the error
      throw error;
    }
  }
  async register(dto) {
    try {
      const response = await registerUser(dto);
      localStorage.setItem("token", response.data.token);
      this.mutations.setAuth(true);
      // Update the Pinia user store with full user data
      const userStore = useUserStore();
      try {
        await userStore.updateStore();
      } catch (error) {
        console.warn('Failed to update user store after registration:', error);
      }
    } catch (error) {
      console.error('Registration failed:', error);
      // Re-throw so components can handle the error
      throw error;
    }
  }
  async logout() {
    try {
      await logoutUser();
    } catch (error) {
      console.error('Logout API call failed:', error);
      // Continue with local cleanup even if API call fails
    }
    localStorage.removeItem("token");
    this.mutations.setAuth(false);
    // Clean the Pinia user store
    const userStore = useUserStore();
    userStore.cleanAll();
  }
}
export const authModule = new Module({
  state: AuthState,
  getters: AuthGetters,
  mutations: AuthMutations,
  actions: AuthActions,
});
export const useAuthModule = createComposable(authModule);
